<template>
    <div id="sysParam">
        <div class="orgLeft" :style="myAutoContent">
            <el-container style="height:100%;width:100%">
                <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
                    <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText" style="width:170px"></el-input>&nbsp;&nbsp;
                    <el-button type="text" size="mini" @click="addParam">
                        <i class="fa fa-plus"></i>
                    </el-button>
                </el-header>

                <el-main style="height:100%;padding:10px;width:100%">
                    <el-tree :props="defaultProps" node-key="id" :data="returnData" accordion :expand-on-click-node="false" ref="tree2" @node-click="handleNodeClick" :filter-node-method="filterNode" :default-expanded-keys="showKeyArray" :highlight-current="true">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span v-if="data.parentCode==0">
                                <span class="fa fa-folder-open fa-fw" :title="node.label">{{node.label | ellipsis}}</span>
                            </span>
                            <span v-else>
                                <span class="fa fa-folder-o fa-fw" :title="node.label">{{node.label | ellipsis}}</span>
                            </span>
                            <span>
                                <el-button type="text" size="mini" @click.stop="() => append(data)" v-if="data.parentCode==0">
                                    <i class="fa fa-plus"></i>
                                </el-button>
                                <el-button type="text" style="color:red" size="mini" @click.stop="() => remove(node, data)">
                                    <i class="fa fa-minus"></i>
                                </el-button>
                            </span>
                        </span>
                    </el-tree>
                </el-main>
            </el-container>
        </div>

        <div class="orgRight" :style="myAutoContent">
            <!-- 操作栏 -->
            <div class="commonSearch" ref="commonSearchRef">
                <el-form class="el-form el-form--inline" onsubmit="return false">
                    <span class="titleStyle"></span>
                    <span style="margin-left:20px">{{this.formTitle}}</span>
                    <div style="clear:both"></div>
                </el-form>
            </div>
            <div class="myTable">
                <el-form :model="paramForm" :rules="rules" ref="paramForm" label-width="200px" style="margin-top:10px;" v-loading="loading">
                    <el-form-item label="系统分类" prop="systemId">
                        <el-select v-model.trim="paramForm.systemId" placeholder="请选择系统分类" style="width:500px" clearable>
                            <el-option v-for="item in systemData" :key="item.value" :label="item.key" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级名称" v-if="isShowParentName==true">
                        <el-input v-model.trim="paramForm.parentName" autocomplete="off" placeholder="请输入上级名称" clearable style="width:500px" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="名称" prop="name">
                        <el-input v-model.trim="paramForm.name" autocomplete="off" placeholder="请输入名称" clearable style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="参数编码" prop="code">
                        <el-input v-model.trim="paramForm.code" autocomplete="off" placeholder="自动生成" clearable style="width:500px" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="扩展值" prop="extCode" v-if="isShowExtCode==true">
                        <el-input v-model.trim="paramForm.extCode" placeholder="请输入扩展值" clearable style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" v-model.trim="paramForm.remark" placeholder="请输入备注" clearable style="width:500px"></el-input>
                    </el-form-item>
                    <el-form-item label="排序号" prop="sortId">
                        <el-input v-model.number="paramForm.sortId" placeholder="请输入排序号" clearable style="width:500px"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit('paramForm')" style="width:100px;margin-top:10px" :disabled="btnDisabled">保存</el-button>
                        <el-button type="primary" @click="clearParam" style="width:100px;margin-top:10px">清空</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div></div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";

import _ from "lodash";
export default {
    filters: {
        ellipsis (value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    mixins: [TabResize],
    components: {},
    mounted: function () {
        //初始化
        this.loading = false;
        this.formTitle = "新增";
        this.per_page = this.$constant.PAGE_SIZE;
        this.$nextTick(() => {
            this.myAutoContent.height = this.myAutoContentHeight + "px";
            this.myTabHeight = this.myAutoContentInnerHeight + "px";
            this.onloadGroup();
            this.initSystemData();
        });
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure addEventListener  resize ---");
        }
        window.addEventListener("resize", this.$mainResize);
    },
    computed: {
        myAutoContentHeight () {
            return this.getMyAutoContentHeight();
        },
        myAutoContentInnerHeight () {
            return this.getMyAutoContentInnerHeight();
        },
        $mainResize () {
            return _.debounce(() => {
                if (this.myAutoContent.height) {
                    this.myAutoContent.height = this.getMyAutoContentHeight() + "px";
                    this.myTabHeight = this.getMyAutoContentInnerHeight() + "px";
                } else {
                    if (this.$constant.DEV_MODE) {
                        console.log(" this.myAutoContentHeight 不存在");
                    }
                }
            }, 400);
        }
    },
    deactivated () {
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure removeEventListener  resize ---");
        }
        window.removeEventListener("resize", this.$mainResize);
    },
    data () {
        return {
            myAutoContent: {
                height: "600px",
                "overflow-y": "auto"
            },
            myTabHeight: 400,
            defaultProps: {
                children: "subs",
                label: "name",
                isLeaf: "leaf"
            },
            systemData: [],
            mainParentId: "",
            mainParentCode: "",
            mainParentName: "",
            formTitle: "",
            overAllCode: "",
            filterText: "",
            isShowCode: false,
            isShowExtCode: false,
            isShowParentName: false,
            loading: false,
            btnDisabled: false,
            returnData: [],
            showKeyArray: [],
            cur_page: 1,
            multipleSelection: [],
            paramForm: {
                name: "",
                code: "",
                extCode: "",
                parentCode: 0,
                parentName: "",
                remark: "",
                sortId: 1,
                systemId: this.$constant.CATALOG + ""
            },
            rules: {
                name: [
                    { required: true, message: "类型名称不能为空", trigger: "blur" },
                    {
                        min: 1,
                        max: 50,
                        message: "类型名称输入不能超过50个字符，请重新输入",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
                        message: "不允许输入空格等特殊符号"
                    }
                ],
                // code: [
                //   { required: true, message: "Code编码不能为空", trigger: "blur" }
                // ],
                extCode: [
                    { required: false, message: "扩展值不能为空", trigger: "blur" },
                    {
                        min: 1,
                        max: 50,
                        message: "扩展值输入不能超过50个字符，请重新输入",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
                        message: "不允许输入空格等特殊符号"
                    }
                ],
                remark: [
                    { required: false, message: "备注不能为空", trigger: "blur" },
                    {
                        min: 1,
                        max: 255,
                        message: "备注输入不能超过255个字符，请重新输入",
                        trigger: "blur"
                    }
                    // {
                    //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
                    //   message: "不允许输入空格等特殊符号"
                    // }
                ],
                sortId: [
                    {
                        required: true,
                        message: "排序不能为空",
                        trigger: "blur"
                    },
                    {
                        validator: function (rule, value, callback) {
                            if (value != null && value != "") {
                                if (/^[1-9]\d{0,8}$/.test(value) == false) {
                                    callback(new Error("只能输入0-9位的数字"));
                                } else {
                                    callback();
                                }
                            } else {
                                return callback();
                            }
                        }
                    }
                ],
                systemId: [
                    { required: false, message: "系统ID不能为空", trigger: "change" }
                ]
            }
        };
    },
    watch: {
        filterText (val) {
            this.$refs.tree2.filter(val);
        }
    },
    methods: {
        append (data) {
            let id = data.id;
            this.mainParentId = data.id;
            this.mainParentCode = data.code;
            this.mainParentName = data.name;
            this.isShowParentName = true;
            this.isShowExtCode = true;
            this.rules.extCode[0].required = true;
            const newChild = { id: id++, name: "请输入", subs: [] };
            if (!data.subs) {
                this.$set(data, "subs", []);
            }
            // data.subs.push(newChild);
            setTimeout(() => {
                this.formTitle = "新增";
                this.paramForm = {
                    id: "",
                    name: "",
                    code: "",
                    extCode: "",
                    parentCode: data.code,
                    parentName: data.name,
                    remark: "",
                    sortId: 1,
                    systemId: data.systemId
                };
            }, 100);
        },

        remove (node, data) {
            if (data.subs != null && data.subs.length > 0) {
                this.$message.error("存在子节点，无法删除。");
                return;
            }
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    SettingApi.getClass()
                        .getSysParamById(data.id)
                        .then(res2 => {
                            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                                this.deleteData(data.id, node);
                            } else if ("10045" == res2.data.code) {
                                const parent = node.parent;
                                const subs = parent.data.subs || parent.data;
                                const index = subs.findIndex(d => d.id === data.id);
                                subs.splice(index, 1);
                            } else {
                                this.$message.error(res2.data.msg);
                                return false;
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                            return false;
                        });
                })
                .catch(() => { });
        },
        getMyAutoContentHeight () {
            let defTagsHeight = this.$constant.DEF_TAGS_HEIGHT;
            let defSearchHeight = 0;
            let defHomeHeight = 600;

            if (this.$refs.commonSearchRef) {
                defSearchHeight = this.$refs.commonSearchRef.clientHeight;
            }
            if (
                this.$parent.$refs.myHomeTagsRef &&
                this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
            ) {
                defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
                    .clientHeight;
            }

            defHomeHeight =
                window.innerHeight -
                this.$constant.DEF_HEADER_HEIGHT -
                defTagsHeight -
                this.$constant.DEF_PADDING_HEIGHT -
                defSearchHeight;
            return defHomeHeight;
        },
        getMyAutoContentInnerHeight () {
            let autoContentHeight = this.getMyAutoContentHeight();
            let defHomeHeight = 400;
            let defOperHeight = 47;
            if (this.$refs.commonOperBtnRef) {
                defOperHeight = this.$refs.commonOperBtnRef.clientHeight;
            }
            defHomeHeight = autoContentHeight - defOperHeight;
            return defHomeHeight;
        },
        filterNode (value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        //获取选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        onloadGroup () {
            let param = {
                parentCode: this.overAllCode
            };
            // this.$mhttp.httpGet(
            //   this.$constant.API_NSC + "uc/dict/dicts",
            //   param,
            //   null
            // );

            SettingApi.getClass()
                .onloadSysParamGroup(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.returnData = res2.data.data;
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        handleNodeClick (data, node, vuecomponent) {
            console.log(
                "data:",
                data,
                "\n",
                "node:",
                node,
                "\n",
                "vuecomponent",
                vuecomponent
            );
            this.formTitle = "编辑";
            this.mainParentId = data.id;
            this.mainParentCode = data.parentCode;
            this.mainParentName = data.name;
            //1级
            if (data.parentCode == 0) {
                this.isShowParentName = false;
                this.isShowExtCode = false;
                // this.isShowCode=true;
            } else {
                //2级
                // this.isShowCode = true;
                this.isShowParentName = true;
                this.isShowExtCode = true;
            }
            this.getParent(data.id);
            // this.showKeyArray = [];
            // this.showKeyArray.push(data.id);
            // this.paramForm.parentCode = data.code;
            // this.paramForm.parentName = data.name;
        },
        deleteData (id, node) {
            let idList = new Array();
            if (id != "" && id != null) {
                idList.push(id);
            }
            let param = {
                ids: idList
            };
            SettingApi.getClass()
                .deleteSysParamById(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.$message.success("删除成功！");
                        this.clearParam();
                        const parent = node.parent;
                        const subs = parent.data.subs || parent.data;
                        const index = subs.findIndex(d => d.id === id);
                        subs.splice(index, 1);
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },
        onSubmit (formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.btnDisabled = true;
                    var v = this.paramForm;
                    var url = "";
                    let param = {
                        id: v.id,
                        parentCode: v.parentCode,
                        name: v.name,
                        // code: v.code,
                        extCode: v.extCode,
                        remark: v.remark,
                        sortId: v.sortId,
                        systemId: v.systemId
                    };
                    // this.$mhttp.httpPost(
                    //   this.$constant.API_NSC + "uc/dict/saveOrUpdate",
                    //   param,
                    //   "application/json"
                    // );

                    SettingApi.getClass()
                        .saveSysParam(param)
                        .then(res2 => {
                            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                                this.loading = false;
                                this.btnDisabled = false;
                                this.$message.success("保存成功！");
                                this.onloadGroup();
                                // this.isShowParentName = false;
                                // this.clearParam();
                                this.paramForm.name = "";
                                this.paramForm.extCode = "";
                                this.paramForm.remark = "";
                                this.paramForm.sortId = "";
                                this.$refs["paramForm"].clearValidate();
                                this.showKeyArray = [];
                                this.showKeyArray.push(this.mainParentId);
                            } else {
                                this.loading = false;
                                this.btnDisabled = false;
                                this.$message.error(res2.data.msg);
                                return false;
                            }
                        })
                        .catch(err => {
                            this.loading = false;
                            this.btnDisabled = false;
                            this.$message.error(err);
                            return false;
                        });
                } else {
                    this.loading = false;
                    this.btnDisabled = false;
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        addParam () {
            this.isShowParentName = false;
            this.isShowExtCode = false;
            this.isShowCode = false;
            this.formTitle = "新增";
            this.paramForm = {
                id: "",
                name: "",
                parentCode: 0,
                remark: "",
                sortId: 1,
                systemId: this.systemData[0].value
            };
        },
        clearParam () {
            if (this.mainParentId == null) {
                this.paramForm.parentCode = this.mainParentCode;
                this.paramForm.parentName = this.mainParentName;
            }
            this.paramForm.name = "";
            this.paramForm.systemId = "";
            this.paramForm.extCode = "";
            this.paramForm.remark = "";
            this.paramForm.sortId = "";
        },
        getParent (id) {
            // this.$mhttp.httpGet(this.$constant.API_NSC + "uc/dict/" + id, null, null);
            SettingApi.getClass()
                .getSysParamById(id)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        this.$refs["paramForm"].clearValidate();
                        this.paramForm = {
                            id: data.id,
                            name: data.name,
                            code: data.code,
                            extCode: data.extCode,
                            parentCode: data.parentCode,
                            parentName: data.parentName,
                            remark: data.remark,
                            //rules验证需要为字符串
                            sortId: data.sortId,
                            systemId: data.systemId
                        };
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },
        initSystemData () {
            SettingApi.getClass()
                .loadSystems()
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        let obj = {};
                        this.systemData = [];
                        for (let i = 0; i < data.length; i++) {
                            obj = {
                                value: data[i].id + "",
                                key: data[i].name
                            };
                            this.systemData.push(obj);
                        }
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        }
    }
};
</script>


<style lang="stylus" scoped>
#sysParam {
    width: 100%;

    .orgLeft {
        width: 250px;
        float: left;
        margin-left: $content-margin-left;
        background-color: white;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }

    .orgRight {
        margin-top: $content-margin-top;
        margin-right: $content-margin-right;
        background-color: white;
        width: auto;
        margin-left: 260px;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }
}

.head-right {
    float: right;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $default-font;
    padding-right: 8px;
}

.titleStyle {
    border-left: 2px solid $theme-color;
}
</style>

